import { BaseBean } from './BaseBean';
import { ConfiguracionPlanBean } from './ConfiguracionPlanBean';
import { MetaBean } from './MetaBean';

export class  ObjetivoBean extends BaseBean {

	public id:number;
	public nombre:string;
	public descripcion:string;
	public avance:number;
	public configuracionPlan:ConfiguracionPlanBean;
  public objetivoPadre:ObjetivoBean;
  public fechaUltimoAvance : Date;
  public publicado: string;

  public perteneceArrayObjetivoPadre:boolean;
  public objetivosHijosList:ObjetivoBean[];
  public metaList:MetaBean[];

  public abrirDesdeMenu?:boolean;
  public modificarDesdeHeader?:boolean;
  public cantidadMetasCumplidas?:number;
  public cantidadObjetivosHijos?:number;

  public linkImagenObjetivo:string;

}
